import { makeAutoObservable } from 'mobx'
import { type BillingInterval } from 'entities/Billing/api/types'
import { type IResponseSubscriptionPlan } from 'entities/Subscription/api/types'

export class SubscriptionPlan {
  id: string
  active: boolean
  seats_plan_id: string
  shared_inboxes_plan_id: string
  compliance_plan_id: string
  custom_domain_plan_id: string
  name: string
  additional_credit_amount: number
  custom: boolean
  price: number
  meta: null
  interval: BillingInterval
  features: IResponseSubscriptionPlan['features']
  limits: IResponseSubscriptionPlan['limits']
  rates: IResponseSubscriptionPlan['rates']

  origin: IResponseSubscriptionPlan

  constructor(item: IResponseSubscriptionPlan) {
    this.id = item.id
    this.active = item.active
    this.seats_plan_id = item.seats_plan_id
    this.shared_inboxes_plan_id = item.shared_inboxes_plan_id
    this.compliance_plan_id = item.compliance_plan_id
    this.custom_domain_plan_id = item.custom_domain_plan_id
    this.name = item.name
    this.additional_credit_amount = item.additional_credit_amount
    this.custom = item.custom
    this.price = item.price
    this.meta = item.meta
    this.interval = item.interval === 'yearly' ? 'annual' : item.interval
    this.features = item.features
    this.limits = item.limits
    this.rates = item.rates

    this.origin = item

    makeAutoObservable(this)
  }
}
